import { createApp } from '@app/adapters/create-app'
import createMeetingPreparationStore from '@app/application/client_meetings/screens/prepare/stores/main'
import MeetingPresentation from '@app/application/client_meetings/screens/present/components/main-view.vue'
import MeetingPresentationHeader from '@app/application/client_meetings/screens/present/components/main-header.vue'
import MeetingPresentationHeaderRight from '@app/application/client_meetings/screens/present/components/header-right.vue'
import PresentingToggle from '@app/application/client_meetings/screens/present/components/presenting-toggle.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='presenting-toggle']").each(function () {
    createApp(PresentingToggle).mount(this)
  })

  const dataElement = document.getElementById(
    'page-data/client-meetings/present'
  )

  if (!dataElement) {
    return
  }

  const pageData = JSON.parse(dataElement.textContent)

  const store = createMeetingPreparationStore({
    firmId: Silverfin.currentFirmId,
    companyId: Silverfin.currentCompanyId,
  })

  $dom
    .find("[data-behaviour='client-meetings-presentation']")
    .each(function () {
      const app = createApp(MeetingPresentation)

      app.provide('pageData', pageData)
      app.use(store)

      app.mount(this)
    })

  $dom
    .find("[data-behaviour='client-meetings-presentation-header']")
    .each(function () {
      const app = createApp(MeetingPresentationHeader)

      app.provide('pageData', pageData)
      app.use(store)

      app.mount(this)
    })

  $dom
    .find("[data-behaviour='client-meetings-presentation-header-right']")
    .each(function () {
      const app = createApp(MeetingPresentationHeaderRight, { pageData })

      app.use(store)

      app.mount(this)
    })
})
